/**
 * Cybersource Form Component
 * Auto-submits to Cybersource Secure Acceptance Hosted Checkout
 *
 * This redirects the user to Cybersource's secure page where they enter
 * ALL payment details including billing information and card details.
 * We only send the signed fields from our backend.
 */

import { useEffect, useRef } from 'react';

interface CybersourceFormProps {
  cybersourceUrl: string;
  cybersourceData: Record<string, string>;
  shouldSubmit: boolean;
}

export default function CybersourceForm({
  cybersourceUrl,
  cybersourceData,
  shouldSubmit,
}: CybersourceFormProps) {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (shouldSubmit && formRef.current) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        formRef.current?.submit();
      }, 100);
    }
  }, [shouldSubmit]);

  return (
    <form
      ref={formRef}
      action={cybersourceUrl}
      method="POST"
      acceptCharset="UTF-8"
      style={{ display: 'none' }}
      aria-hidden="true"
    >
      {/*
        All signed fields from backend (access_key, profile_id, transaction_uuid,
        signed_field_names, unsigned_field_names, signed_date_time, locale,
        transaction_type, reference_number, amount, currency, signature, etc.)

        Cybersource Hosted Checkout will collect ALL user information including:
        - Billing name and address
        - Contact information (email, phone)
        - Credit card details
      */}
      {Object.entries(cybersourceData).map(([key, value]) => (
        <input key={key} type="hidden" name={key} value={value} />
      ))}
    </form>
  );
}
